module.exports = __webpack_public_path__ + "static/media/circle.c15b3700.svg";